import { StaticValue_Decreased, StaticValue_Increased, StaticValue_Normal, valueType_Enumerated, valueType_Range, valueType_StandardRange, valueType_SubEnumerated, valueType_Time, valueType_Tuple } from '@app/hcs-shared/core';
export function filterRelevantValues(value) {
    let relevantValues = [];
    if (!value)
        return relevantValues;
    switch (value.type) {
        case valueType_Range:
            relevantValues = value.data.subsets;
            break;
        case valueType_SubEnumerated:
        case valueType_Enumerated:
        case valueType_Tuple:
            relevantValues = value.data.scope;
            break;
        case valueType_Time:
            relevantValues = value.data.timeRanges;
            break;
        case valueType_StandardRange:
            relevantValues = [StaticValue_Decreased._id, StaticValue_Normal._id, StaticValue_Increased._id];
            break;
    }
    return relevantValues;
}
//# sourceMappingURL=utils.js.map